import { generateId } from '@freelancer/datastore/testing/helpers';
import { ContextTypeApi } from 'api-typings/common/common';
import {
  ProjectCollaborationPermissionApi,
  ProjectCollaborationStatusApi,
} from 'api-typings/projects/projects';
import type { ProjectCollaboration } from './project-collaborations.model';
import type { GenerateProjectViewProjectOptions } from '../project-view-projects/project-view-projects.seed';

export interface GenerateProjectCollaborationsOptions {
  readonly userIds: readonly number[];
  readonly projectId: number;
  readonly projectOwnerId: number;
  readonly status?: ProjectCollaborationStatusApi;
}

export interface GenerateProjectCollaborationOptions {
  readonly userId: number;
  readonly projectId: number;
  readonly projectOwnerId: number;
  readonly status?: ProjectCollaborationStatusApi;
}

export function generateProjectCollaborationObjects({
  userIds,
  projectOwnerId,
  projectId,
  status = ProjectCollaborationStatusApi.ACTIVE,
}: GenerateProjectCollaborationsOptions): readonly ProjectCollaboration[] {
  return userIds.map(userId =>
    generateProjectCollaborationObject({
      userId,
      projectOwnerId,
      projectId,
    }),
  );
}

export function generateProjectCollaborationObject({
  userId,
  projectOwnerId,
  projectId,
  status = ProjectCollaborationStatusApi.ACTIVE,
}: GenerateProjectCollaborationOptions): ProjectCollaboration {
  return {
    id: generateId(),
    userId,
    context: {
      id: projectId,
      type: ContextTypeApi.PROJECT,
    },
    contextOwnerId: projectOwnerId,
    permissions: [
      ProjectCollaborationPermissionApi.CHAT,
      ProjectCollaborationPermissionApi.BID_AWARD,
    ],
    status,
  };
}

// --- Mixins for project state ---

export function awardAndChatCollaborator({
  userId,
  projectId,
  projectOwnerId,
}: GenerateProjectCollaborationOptions): Pick<
  GenerateProjectViewProjectOptions,
  'projectCollaborations'
> {
  return {
    projectCollaborations: [
      generateProjectCollaborationObject({
        userId,
        projectOwnerId,
        projectId,
      }),
    ],
  };
}
